var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M360.016 172.016h-64a8 8 0 0 1 0-16h64a8 8 0 0 1 0 16z",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M328.016 204.016a8 8 0 0 1-8-8v-64a8 8 0 0 1 16 0v64a8 8 0 0 1-8 8zM232.016 244.016h-64a8 8 0 0 1 0-16h64a8 8 0 0 1 0 16z",
    fill: "#263238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M200.016 276.016a8 8 0 0 1-8-8v-64a8 8 0 0 1 16 0v64a8 8 0 0 1-8 8zM220.016 900.016h-32a8 8 0 0 1 0-16h32a8 8 0 0 1 0 16zM412.736 900.016H252.016a8 8 0 0 1 0-16h160.72a151.568 151.568 0 0 0 103.968-41.12l81.84-76.72a8 8 0 1 1 10.944 11.68l-81.84 76.72a167.52 167.52 0 0 1-114.912 45.44z",
    fill: "#263238"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M864.016 172.016l-704 312 216 64 64 232 163.888-164.752 212.112 60.752z",
    fill: "#40C4FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M440 788.016a8 8 0 0 1-7.712-5.888l-62.816-227.712L157.728 491.68a8.016 8.016 0 0 1-0.976-14.976l704-312a7.968 7.968 0 0 1 11.2 8.08l-48 504a8 8 0 0 1-10.16 6.912L606.24 624.256 445.68 785.664a8.032 8.032 0 0 1-5.68 2.352zM183.12 482.512l195.152 57.824c2.656 0.784 4.704 2.88 5.44 5.552l60.336 218.72 154.176-154.992a7.856 7.856 0 0 1 7.872-2.048l202.848 58.096 45.792-480.8-671.616 297.648z",
    fill: "#263238"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M603.904 623.264a8.24 8.24 0 0 1-2.464-0.384l-83.888-27.248a7.984 7.984 0 0 1-3.696-12.704l298.544-361.024-431.504 332.448a8.016 8.016 0 0 1-9.76-12.688l488-376a8 8 0 1 1 11.056 11.44L533.664 584.048l72.688 23.616a7.984 7.984 0 0 1-2.448 15.6z",
    fill: "#263238"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M440 788.016a8 8 0 0 1-7.376-11.072l80-192a8 8 0 0 1 14.768 6.144l-80 192a7.984 7.984 0 0 1-7.392 4.928z",
    fill: "#263238"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2c5e184b2560c377b4971289309b8f0e.svg";
export { ForwardRef as ReactComponent };